module.exports = __webpack_public_path__ + "static/img/szpt22.7690c49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szpt22.jpg
// module id = 4eDn
// module chunks = 73